module.exports = __webpack_public_path__ + "img/header-engagementRings@2x.8e90e18.jpg";